export default "__VITE_ASSET__o8UuTNgk__"